import React from "react";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";
import FormUserUpload from "./FormUserUpload";

const UploadUser = () => (
  <Layout>
    <HeaderUser />
    <section className="layout-container">
      <div className="container">
        <div className="form-title g-clr">Upload Users</div>
        <div className="descript-container">
          The data in the CSV file prepared for upload must not contain any
          commas, as CSV format uses commas as field separators. Any comma
          within a field will disrupt the formatting. The first line in the file
          is a fixed header containing field names, as shown in the screenshot
          of the sample file below. This header line is also included in the CSV
          template. Please ensure you save your upload file in CSV
          (comma-separated values) format.
        </div>
        <FormUserUpload />
      </div>
    </section>
  </Layout>
);

export default UploadUser;
